import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  private called = false;
  constructor() {}

  // Returns window.appData once only, then returns undefined
  public get appData() {
    if (this.called) {
      return undefined;
    }

    this.called = true;

    return (<any>window).appData;
  }
}
